<template>
    <form class="admin-linear-form" @submit.prevent="proceed" @keydown="localeForm.errors.clear($event.target.name)">
        <div class="admin-linear-form__grid">
            <div class="admin-linear-field">
                <label>{{trans('locale.name')}}</label>
                <input class="form-control" type="text" value="" v-model="localeForm.name" name="name" :placeholder="trans('locale.name')">
                <show-error :form-name="localeForm" prop-name="name"></show-error>
            </div>
            <div class="admin-linear-field">
                <label>{{trans('locale.locale')}}</label>
                <input class="form-control" type="text" value="" v-model="localeForm.locale" name="locale" :placeholder="trans('locale.locale')">
                <show-error :form-name="localeForm" prop-name="locale"></show-error>
            </div>
        </div>
        <div class="admin-linear-form__actions">
            <button type="button" class="btn btn-sm admin-form-btn-cancel" v-if="!id" @click="$emit('cancel')">
                {{trans('general.cancel')}}
            </button>
            <router-link to="/configuration/locale" class="btn btn-sm admin-toolbar-btn admin-toolbar-btn--outline" v-show="id">{{trans('general.cancel')}}</router-link>
            <button type="submit" class="btn btn-sm admin-toolbar-btn admin-toolbar-btn--solid">
                <span v-if="id">{{trans('general.update')}}</span>
                <span v-else>{{trans('general.save')}}</span>
            </button>
        </div>
    </form>
</template>


<script>
    export default {
        data() {
            return {
                localeForm: new Form({
                    name : '',
                    locale : ''
                })
            };
        },
        props: ['id'],
        mounted() {
            if(this.id)
                this.getLocale();
        },
        methods: {
            proceed(){
                if(this.id)
                    this.updateLocale();
                else
                    this.storeLocale();
            },
            storeLocale(){
                this.localeForm.post('/api/locale')
                    .then(response => {
                        toastr.success(response.message);
                        this.$emit('completed')
                    })
                    .catch(error => {
                        helper.showErrorMsg(error);
                    });
            },
            getLocale(){
                axios.get('/api/locale/'+this.id)
                    .then(response => response.data)
                    .then(response => {
                        this.localeForm.name = response.name;
                        this.localeForm.locale = response.locale;
                    })
                    .catch(error => {
                        helper.showDataErrorMsg(error);
                        this.$router.push('/configuration/locale');
                    });
            },
            updateLocale(){
                this.localeForm.patch('/api/locale/'+this.id)
                    .then(response => {
                        toastr.success(response.message);
                        this.$router.push('/configuration/locale');
                    })
                    .catch(error => {
                        helper.showErrorMsg(error);
                    });
            }
        }
    }
</script>

<style scoped>
.admin-linear-form {
    display: grid;
    gap: 1rem;
}

.admin-linear-form__grid {
    display: grid;
    gap: 1rem;
    grid-template-columns: repeat(2, minmax(0, 1fr));
}

.admin-linear-field label {
    display: block;
    margin-bottom: 0.45rem;
    color: var(--dash-pro-text);
    font-size: 0.75rem;
    font-weight: 700;
    letter-spacing: 0.04em;
    text-transform: uppercase;
}

.admin-linear-form__actions {
    display: flex;
    flex-wrap: wrap;
    justify-content: flex-end;
    gap: 0.65rem;
    padding-top: 0.35rem;
}

@media (max-width: 575.98px) {
    .admin-linear-form__grid {
        grid-template-columns: 1fr;
    }
}
</style>
